import type { IconData } from '@stacksjs/iconify-core'

export const italic: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m2.273 8l1.95-6H3a1 1 0 1 1 0-2h5a1 1 0 1 1 0 2H6.326l-1.95 6H6a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default italic
